export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/water.86277690.svg","height":166,"width":165,"blurWidth":0,"blurHeight":0};